/**
 * Una flashcard generada por IA. statement es el anverso (lo que hay que recordar) y answer el
 * reverso (lo que lo afianza); los nombres son los de FlashcardEntity para que el componente que
 * ya pinta y gira tarjetas sirva tal cual.
 */
export class AiGeneratedFlashcardDto {
  id: number;
  reference: string;
  statement: string;
  answer: string;
  subjectId: number;
  subjectName: string;
  topicId: number;
  topicName: string;
  difficulty: number;
  keyPoint: string;
  created: string;

  // solo en cliente: marca la tarjeta que se esta aceptando o rechazando ahora mismo
  processing: boolean;
}
